import { Models } from '@rematch/core';
import { connections } from './connections';
import { projects } from './projects';
import { services } from './services';
import { global } from './global';
import { imodels } from './imodels';
import { tab } from './tab';

export interface RootModel extends Models<RootModel> {
  connections: typeof connections;
  projects: typeof projects;
  services: typeof services;
  global: typeof global;
  imodels: typeof imodels;
  tab: typeof tab;
}

export const models: RootModel = {
  connections,
  projects,
  services,
  global,
  imodels,
  tab,
};
